import React, {Component} from 'react';
import App from "../../App";
import { OverlayTrigger, Tooltip} from "react-bootstrap";
import { FiEye } from "react-icons/all";
import { GiMoneyStack } from 'react-icons/gi';
import {withRouter, Link} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import {toast} from 'react-toastify';
import { getList, destroy } from "../../services/baseServices";

class List extends Component {
  constructor() {
    super();
    this.state = {
      distributors: [],
      formData: {},
      isFormValidated: false,
      isLoadingData: true,
      isSubmitting: false,
      selectedFile: null,
    };
  }

  componentDidMount() {
    getList("distributors")
      .then(res => {
        this.setState({distributors: res})
      })
      .catch(errMsg => {
        console.log('Err Msg: ', errMsg)
      })
  }

  render() {
    return (
      <App layout="">
        <div className="main-content">
          <div className="page-header">
            <h2 className="page-title">Distribution House List</h2>
          </div>

          <div className="card-block">
            <div className="block-body">

              <table className="order-table table table-striped">
                <thead>
                <tr>
                  <th style={{width: '20px'}}>#</th>
                  <th>Name</th>
                  <th>Name in Bangla</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                {this.state.distributors.length > 0 ? this.state.distributors.map((item, index) => {
                  return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="order-item">
                            {item.name}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                            {item?.bn_name}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                            {item?.email}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                            {item?.phone}
                          </div>
                        </td>
                        <td style={{width: '150px'}}>
                          <div className="btn-group">
                            <OverlayTrigger
                              key="view"
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-view`}>
                                  Commission
                                </Tooltip>
                              }
                            >
                              <Link to={`${process.env.PUBLIC_URL}/dh/commission/${item.id}`}
                                className="btn btn-sm btn-default"><GiMoneyStack/></Link>
                            </OverlayTrigger>
                          </div>
                          <div className="btn-group">
                            &nbsp;
                            <OverlayTrigger
                              key="view"
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-view`}>
                                  Details
                                </Tooltip>
                              }
                            >
                              <Link to={`${process.env.PUBLIC_URL}/dh/details/${item.id}`}
                                className="btn btn-sm btn-default"><FiEye/></Link>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                  );
                }) : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </App>
    );
  }
}

export default withRouter(List);
